import(/* webpackMode: "eager" */ "/vercel/path1/app/vocab/quiz/page.tsx");
